module.exports = {"tc":{"nameShownAs":"自強號","includes":["1","2","3"]},"ck":{"nameShownAs":"莒光號","includes":["4"]},"lt":{"nameShownAs":"區間車","includes":["5","6","7","10"]},"trk":{"nameShownAs":"太魯閣號","includes":["1"]},"pym":{"nameShownAs":"普悠瑪號","includes":["2"]},"tilting":{"nameShownAs":"傾斜式列車","includes":["1","2"]},"reserved":{"nameShownAs":"對號列車","includes":["1","2","3","4"]}}


//////////////////
// WEBPACK FOOTER
// ./static/trainTypeMaps.json
// module id = ZX8f
// module chunks = 1